module.exports = __webpack_public_path__ + "static/media/top_catch.9853ff66.png";